module.exports = __webpack_public_path__ + "img/hips.59e5c1f6.png";